import React, { useEffect, useRef, useState } from "react";
import { HiArrowNarrowRight, HiArrowNarrowLeft } from 'react-icons/hi';
import { Typography } from 'antd';
import { Avatar } from 'antd';
import ProfileImage from '../../assets/profileIcon.jfif'
import { IoIosNotifications } from 'react-icons/io';
import styles from "./Header.module.css";
import { useNavigate, useLocation } from "react-router";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { roles } from "../../config/roles";
import { useSelector } from "react-redux";
import dummyImg from '../../assets/dummy.png';
import glugSfx from '../../assets/notification.mp3';

import { IMG_URL } from "../../store/Apis";
import { useTranslation } from "react-i18next";
import pusherJs from "pusher-js";

const Header = ({ onBackClick, title, collapsed }) => {
  const { t, i18n } = useTranslation();
  const { height, width } = useWindowDimensions();
  const role = localStorage.getItem('role');
  const { Text } = Typography;
  const navigation = useNavigate()
  const location = useLocation();
  const channel = useRef(null)
  const [notificationCount, setnotificationCount] = useState()
  const user = useSelector(state => state.AuthReducer.user)


  const userData = useSelector((state) => state.AuthReducer.user);
  useEffect(() => {
    getLanguage();
    initiatePusher();
  }, [])


  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };


  const initiatePusher = () => {
    let pusher = new pusherJs('d977b543ea849a1c6f44', { cluster: 'ap2' });
    channel.current = pusher.subscribe('unread_notifications');
    channel.current.bind('App\\Events\\UnreadNotifications', (response) => {
      if (response?.receiver_id == user?.id) {
        console.log('pusher', response)
        setnotificationCount(response?.unread_notifications);
      }
    });
  };
  return (
    <div className={styles.mainHeaderDiv}>
      <div className={styles.headingDiv} >
        <div className={styles.backIcon} onClick={onBackClick}>
          {collapsed ? <HiArrowNarrowRight style={{ color: '#000000', fontSize: 20 }} /> : <HiArrowNarrowLeft style={{ color: '#000000', fontSize: 20 }} />}
        </div>
        <Text className={styles.heading} >{t(title)} <span style={{ color: 'var(--secondary-color)' }}>{location.pathname?.substring(1).split('/')?.map((str, i) => (i != 0 && ' / ' + t(str.replace(/([A-Z])/g, ' $1').trim())))}</span></Text>
      </div>
      <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'center', alignItems: "center" }}>

        {notificationCount ?
          <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'center', alignItems: "center" }}>
            < div style={{ position: 'absolute', backgroundColor: 'red', width: '18px', height: '18px', borderRadius: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Text style={{ color: 'white', fontWeight: 'bold', fontSize: 10 }}>{notificationCount}</Text>
            </div>
            <IoIosNotifications size={40} color={"#f6921e"} style={{ cursor: "pointer", marginRight: "20px" }} onClick={() => navigation('/Notifications')} />

          </div>

          :
          <IoIosNotifications size={40} color={"#f6921e"} style={{ cursor: "pointer", marginRight: "20px" }} onClick={() => navigation('/Notifications')} />
        }

        <Avatar size="large" style={{ cursor: "pointer" }} onClick={() => {
          navigation('profile');
        }} icon={
          <img src={userData?.profile_image ? IMG_URL + userData?.profile_image : dummyImg} width={200} height={100} />
        } />

      </div>
    </div >
  )
}

export default Header;